/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener("DOMContentLoaded", function () {
  var canvas = document.getElementById("imageCanvas");
  if (!canvas) return;
  var ctx = canvas.getContext("2d");
  var image = document.querySelector('img[usemap="#safetygearmap"]');
  if (!image) return;
  var originalWidth = image.naturalWidth || 332;

  var areas = [
    {
      coords: [
        123, 4, 152, 4, 170, 18, 175, 31, 177, 44, 112, 44, 104, 52, 100, 47,
        100, 37, 107, 19, 123, 4,
      ],
      type: "hard-hats",
      color: "#FF0033",
      url: "https://www.wryker.com/collections/hard-hats",
      button: "hard-hats",
    },
    {
      coords: [
        108, 63, 108, 72, 118, 77, 129, 77, 135, 70, 143, 70, 150, 77, 159, 77,
        169, 70, 169, 61, 160, 58, 148, 58, 139, 62, 130, 58, 119, 58, 108, 63,
      ],
      type: "eye-protection",
      color: "#FFFF00",
      url: "https://www.wryker.com/collections/face-eye-protection",
      button: "eye-protection",
    },
    {
      coords: [
        80, 748, 100, 744, 113, 744, 125, 748, 132, 755, 128, 767, 134, 782,
        134, 801, 140, 808, 141, 819, 134, 822, 105, 825, 98, 823, 91, 827, 58,
        833, 27, 820, 27, 809, 32, 798, 51, 796, 60, 793, 67, 787, 78, 777, 82,
        763, 80, 748,
      ],
      type: "shoes",
      color: "#00FF00",
      url: "https://www.wryker.com/collections/shoes-protective-footwear",
      button: "shoes",
    },
    {
      coords: [
        176, 753, 222, 753, 233, 827, 208, 846, 166, 846, 156, 840, 157, 820,
        170, 806, 171, 799, 176, 791, 176, 753,
      ],
      type: "shoes",
      color: "#00FF00",
      url: "https://www.wryker.com/collections/shoes-protective-footwear",
      button: "shoes",
    },
    {
      coords: [
        106, 20, 96, 27, 89, 42, 89, 56, 83, 70, 83, 80, 96, 96, 107, 96, 104,
        53, 99, 47, 100, 33, 106, 20,
      ],
      type: "hearing-protection",
      color: "#007FFF",
      url: "https://www.wryker.com/collections/hearing-protection",
      button: "hearing-protection",
    },
    {
      coords: [
        171, 20, 176, 30, 178, 44, 171, 53, 171, 97, 179, 97, 194, 81, 194, 69,
        188, 56, 186, 40, 180, 26, 171, 20,
      ],
      type: "hearing-protection",
      color: "#007FFF",
      url: "https://www.wryker.com/collections/hearing-protection",
      button: "hearing-protection",
    },
    {
      coords: [
        12, 398, 27, 398, 44, 410, 44, 420, 49, 426, 48, 441, 34, 458, 20, 457,
        4, 442, 12, 398,
      ],
      type: "gloves",
      color: "#B026FF",
      url: "https://www.wryker.com/collections/gloves-and-hand-protection",
      button: "gloves",
    },
    {
      coords: [
        78, 136, 48, 152, 40, 165, 34, 184, 34, 265, 22, 294, 21, 352, 16, 383,
        13, 390, 14, 396, 28, 396, 46, 408, 57, 356, 57, 335, 60, 322, 60, 314,
        68, 294, 75, 286, 74, 274, 74, 267, 69, 260, 69, 240, 73, 233, 73, 219,
        69, 218, 69, 209, 72, 206, 73, 165, 78, 136,
      ],
      type: "vests",
      color: "orange",
      url: "https://www.wryker.com/collections/workwear",
      button: "vests",
    },
    {
      coords: [
        92, 128, 80, 135, 74, 207, 71, 210, 71, 215, 74, 219, 74, 232, 70, 240,
        70, 259, 74, 265, 75, 276, 76, 286, 68, 298, 62, 318, 60, 336, 58, 370,
        71, 374, 90, 374, 98, 369, 109, 369, 110, 374, 125, 374, 126, 371, 174,
        371, 174, 367, 182, 363, 169, 364, 166, 356, 172, 352, 163, 351, 149,
        347, 109, 347, 104, 350, 95, 342, 72, 339, 78, 325, 85, 305, 89, 284,
        95, 262, 111, 262, 116, 265, 126, 265, 126, 263, 173, 262, 177, 278,
        193, 319, 204, 320, 215, 325, 212, 313, 208, 311, 194, 282, 194, 260,
        198, 255, 198, 240, 194, 237, 194, 222, 203, 133, 186, 125, 179, 210,
        175, 239, 98, 240, 91, 233, 91, 219, 93, 218, 93, 208, 90, 206, 90, 164,
        95, 131, 92, 128,
      ],
      type: "harness",
      color: "#1F51FF",
      url: "https://www.wryker.com/collections/fall-protection",
      button: "harness",
    },
    {
      coords: [
        53, 464, 53, 490, 66, 497, 69, 503, 83, 509, 112, 520, 135, 525, 144,
        523, 196, 508, 205, 507, 219, 495, 225, 497, 223, 465, 211, 466, 194,
        476, 194, 482, 181, 488, 160, 495, 143, 498, 138, 504, 107, 494, 85,
        482, 85, 478, 53, 464,
      ],
      type: "harness",
      color: "#1F51FF",
      url: "https://www.wryker.com/collections/fall-protection",
      button: "harness",
    },
    {
      coords: [
        170, 362, 168, 356, 175, 351, 164, 349, 160, 345, 160, 340, 175, 333,
        164, 324, 166, 317, 190, 319, 204, 322, 216, 327, 224, 327, 234, 339,
        238, 349, 240, 363, 228, 363, 220, 366, 201, 366, 182, 375, 176, 374,
        176, 368, 184, 362, 170, 362,
      ],
      type: "gloves",
      color: "#B026FF",
      url: "https://www.wryker.com/collections/gloves-and-hand-protection",
      button: "gloves",
    },
    {
      coords: [
        217, 325, 223, 325, 226, 304, 223, 298, 230, 281, 239, 232, 272, 254,
        254, 303, 246, 313, 236, 318, 225, 325, 236, 339, 240, 350, 242, 365,
        248, 363, 257, 355, 287, 323, 326, 265, 326, 256, 297, 207, 257, 164,
        255, 157, 246, 144, 223, 136, 204, 134, 195, 222, 195, 236, 199, 239,
        199, 256, 195, 260, 195, 282, 205, 297, 209, 310, 213, 312, 217, 325,
      ],
      type: "vests",
      color: "orange",
      url: "https://www.wryker.com/collections/workwear",
      button: "vests",
    },
    {
      coords: [
        96, 131, 91, 163, 91, 205, 94, 207, 94, 218, 92, 220, 92, 233, 99, 239,
        174, 238, 185, 125, 170, 114, 164, 126, 138, 144, 132, 144, 109, 122,
        96, 131,
      ],
      type: "vests",
      color: "orange",
      url: "https://www.wryker.com/collections/workwear",
      button: "vests",
    },
    {
      coords: [
        96, 263, 90, 287, 86, 305, 80, 325, 73, 338, 95, 340, 104, 347, 108,
        345, 149, 345, 163, 350, 159, 346, 159, 339, 173, 333, 162, 325, 165,
        316, 191, 318, 178, 280, 172, 263, 127, 264, 126, 267, 115, 267, 111,
        264, 96, 263,
      ],
      type: "vests",
      color: "orange",
      url: "https://www.wryker.com/collections/workwear",
      button: "vests",
    },
    {
      coords: [
        59, 373, 56, 389, 86, 393, 100, 379, 112, 397, 121, 398, 143, 405, 219,
        405, 219, 369, 199, 369, 182, 376, 176, 375, 173, 372, 127, 372, 126,
        376, 109, 375, 107, 371, 98, 371, 90, 376, 71, 376, 59, 373,
      ],
      type: "vests",
      color: "orange",
      url: "https://www.wryker.com/collections/workwear",
      button: "vests",
    },
    {
      coords: [
        145, 525, 195, 510, 206, 510, 220, 499, 224, 507, 224, 529, 222, 532,
        227, 575, 221, 583, 225, 589, 225, 599, 226, 717, 224, 732, 229, 752,
        170, 752, 166, 636, 160, 621, 160, 608, 155, 591, 145, 525,
      ],
      type: "pants",
      color: "#FF10F0",
      url: "https://www.wryker.com/collections/pants",
      button: "pants",
    },
    {
      coords: [
        53, 390, 86, 395, 100, 381, 112, 398, 120, 399, 143, 406, 220, 406, 220,
        384, 227, 396, 223, 463, 210, 465, 193, 476, 192, 481, 160, 494, 143,
        496, 138, 503, 87, 482, 87, 477, 52, 463, 49, 457, 53, 390,
      ],
      type: "pants",
      color: "#FF10F0",
      url: "https://www.wryker.com/collections/pants",
      button: "pants",
    },
    {
      coords: [
        57, 494, 66, 498, 68, 504, 111, 522, 137, 526, 130, 597, 130, 672, 127,
        700, 129, 705, 128, 722, 131, 727, 131, 736, 137, 741, 133, 754, 126,
        746, 113, 743, 100, 743, 79, 747, 79, 728, 78, 710, 73, 695, 68, 615,
        66, 611, 66, 590, 62, 589, 56, 576, 58, 550, 56, 547, 57, 494,
      ],
      type: "pants",
      color: "#FF10F0",
      url: "https://www.wryker.com/collections/pants",
      button: "pants",
    },
  ];

  var lastHoveredArea = null; // Store the last hovered area object

  function resizeImageAndRedraw() {
    scale = canvas.offsetWidth / originalWidth; // Calculate the scale factor
    canvas.width = image.offsetWidth;
    canvas.height = image.offsetHeight;
    drawImageAndBorders();
  }

  function drawImageAndBorders() {
    drawImageNormally();
   // drawBorders(); // Initially draw borders for all areas
  }

  function drawImageNormally() {
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
  }

  function drawImageInGrayscale() {
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    applyGrayscale();
  }

  function applyGrayscale() {
    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    for (var i = 0; i < imageData.data.length; i += 4) {
      var avg =
        (imageData.data[i] + imageData.data[i + 1] + imageData.data[i + 2]) / 3;
      imageData.data[i] = avg; // Red
      imageData.data[i + 1] = avg; // Green
      imageData.data[i + 2] = avg; // Blue
    }
    ctx.putImageData(imageData, 0, 0);
  }

  function drawBorders() {
    areas.forEach(function (area) {
      ctx.beginPath();
      ctx.moveTo(area.coords[0] * scale, area.coords[1] * scale); // Scale the coordinates
      for (var i = 2; i < area.coords.length; i += 2) {
        ctx.lineTo(area.coords[i] * scale, area.coords[i + 1] * scale); // Scale the coordinates
      }
      ctx.closePath();
      ctx.strokeStyle = area.color; //
      ctx.lineWidth = 0;
      ctx.stroke();
    });
  }

  function onMouseMove(event) {
    var rect = canvas.getBoundingClientRect();
    var mouseX = event.clientX - rect.left;
    var mouseY = event.clientY - rect.top;

    var hoveredArea = null;
    areas.forEach(function (area) {
      if (isPointInPolygon({ x: mouseX, y: mouseY }, area.coords)) {
        hoveredArea = area; // Store the entire area object
      }
    });

    canvas.style.cursor = hoveredArea ? "pointer" : "default"; // Change cursor based on hover state

    document.querySelectorAll(".items").forEach((link) => {
      if (hoveredArea && link.classList.contains(hoveredArea.button)) {
        link.classList.add("hovered");
      } else {
        link.classList.remove("hovered");
      }
    });

    if (hoveredArea && hoveredArea.type !== lastHoveredArea?.type) {
      drawImageInGrayscale();
      colorAreasOfType(hoveredArea.type); // Color all areas of this type
     // drawBordersForType(hoveredArea.type); // Draw borders for this type
    } else if (!hoveredArea && lastHoveredArea !== null) {
      drawImageAndBorders(); // Redraw the image and all borders correctly with scale
    }

    lastHoveredArea = hoveredArea; // Update the lastHoveredArea with the current one
  }

  function onClick(event) {
    if (lastHoveredArea && lastHoveredArea.url) {
      window.location.href = lastHoveredArea.url; // Redirect to the URL
    }
  }

  function colorAreasOfType(type) {
    areas.forEach(function (area) {
      if (area.type === type) {
        colorArea(area.coords);
      }
    });
  }

  function colorArea(coords) {
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(coords[0] * scale, coords[1] * scale); // Scale the coordinates
    for (var i = 2; i < coords.length; i += 2) {
      ctx.lineTo(coords[i] * scale, coords[i + 1] * scale); // Scale the coordinates
    }
    ctx.closePath();
    ctx.clip();
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    ctx.restore();
  }

  function drawBordersForType(type) {
    areas.forEach(function (area) {
      if (area.type === type) {
        ctx.beginPath();
        ctx.moveTo(area.coords[0] * scale, area.coords[1] * scale); // Apply scale
        for (var i = 2; i < area.coords.length; i += 2) {
          ctx.lineTo(area.coords[i] * scale, area.coords[i + 1] * scale); // Apply scale
        }
        ctx.closePath();
        ctx.strokeStyle = area.color; //"#46D5D9"; // 
        ctx.lineWidth = 0;
        ctx.stroke();
      }
    });
  }

  function isPointInPolygon(point, polygon) {
    var isInside = false;
    for (var i = 0, j = polygon.length - 2; i < polygon.length; i += 2) {
      var xi = polygon[i] * scale,
        yi = polygon[i + 1] * scale; // Scale the coordinates
      var xj = polygon[j] * scale,
        yj = polygon[j + 1] * scale; // Scale the coordinates

      var intersect =
        yi > point.y !== yj > point.y &&
        point.x < ((xj - xi) * (point.y - yi)) / (yj - yi) + xi;
      if (intersect) isInside = !isInside;
      j = i;
    }
    return isInside;
  }

  // code for hover on buttons
  document.querySelectorAll(".items").forEach((link) => {
    link.addEventListener("mouseenter", function () {
      var itemType = this.classList[1]; // Assumes the second class corresponds to the item type
      console.log(itemType);
      drawImageInGrayscale(); // Desaturate the image
      // Highlight areas corresponding to the link's item type
      colorAreasOfType(itemType); // Adjust based on your area types naming
      drawBordersForType(itemType); // Same adjustment as above
    });

    link.addEventListener("mouseleave", drawImageAndBorders);
  });

  if (image.complete && image.naturalHeight !== 0) {
    resizeImageAndRedraw();
  } else {
    image.onload = resizeImageAndRedraw;
  }

  canvas.addEventListener("mousemove", onMouseMove);
  canvas.addEventListener("click", onClick);
  window.addEventListener("resize", resizeImageAndRedraw);
});
(function () {
  'use strict';

  // Use event delegation on the document — works regardless of when DOM is ready
  // and survives Shopify theme editor re-renders
  document.addEventListener('mouseover', function (e) {
    // Find the closest rail item (handles hovering child elements like <a> and <svg>)
    var railItem = e.target.closest('.mega-menu-two__rail-item');
    if (!railItem) return;

    var menuId = railItem.dataset.menuId;
    var idx = railItem.dataset.railIndex;
    var hasPanel = railItem.dataset.hasPanel === 'true';

    // Deactivate all rail items in this menu
    document.querySelectorAll('.mega-menu-two__rail-item[data-menu-id="' + menuId + '"]').forEach(function (el) {
      el.classList.remove('is-active');
    });

    // Mark hovered rail item active
    railItem.classList.add('is-active');

    // Always clear all panels first
    document.querySelectorAll('.mega-menu-two__panel[data-menu-id="' + menuId + '"]').forEach(function (el) {
      el.classList.remove('is-active');
    });

    if (hasPanel) {
      // Show the matching panel
      var panel = document.querySelector('.mega-menu-two__panel[data-menu-id="' + menuId + '"][data-panel-index="' + idx + '"]');
      if (panel) panel.classList.add('is-active');
    }
    // Leaf nodes: panels are all cleared, right side is blank (intentional)
  });
})();